module.exports = __webpack_public_path__ + "img/jiajingding.prt.a7b18fe8.jpg";